import { Component } from "@angular/core";
import { Validators } from "@angular/forms";
import { CrudForm } from "src/app/components/shared/cruds/crud.form";
import { EmpresasDTO } from "src/app/models/empresas.dto";

@Component({
  selector: "app-form-empresa",
  templateUrl: "./form.component.html",
})
export class EmpresaForm extends CrudForm<EmpresasDTO> {
  public fromInit(row: EmpresasDTO) {
    this.form.controls["IdEmpresa"].setValue(row?.IdEmpresa);
    this.form.controls["Nombre"].patchValue(row?.Nombre);
    this.form.controls["Direccion"].patchValue(row?.Direccion);
    this.form.controls["Correo"].patchValue(row?.Correo);
    this.form.controls["Telefono"].patchValue(row?.Telefono);
  }

  protected buildForm() {
    this.form = this.fb.group({
      IdEmpresa: [""],
      Nombre: [""],
      Direccion: [""],
      Telefono: [""],
      Correo: ["", Validators.email],
    });
  }
}
